import React from "react";
import _ from "lodash";

import logo from "assets/images/say-what/saywhat-logo.png";

const MultipleWinners = ({
  photo,
  percentage,
  over_params,
  winning_captions,
  currentPlayer
}) => {
  const lost_text = _.get(over_params, "lost_text", "The Winner");
  const won_text_1 = _.get(over_params, "won_text_1", "YOU WON!");
  const won_text_2 = _.get(over_params, "won_text_2", "% of the votes!");

  const userWon = winning_captions.filter(
    (caption) => caption.player_id === currentPlayer.player_id
  );
  const otherWinners = winning_captions.filter(
    (caption) => caption.player_id !== currentPlayer.player_id
  );
  const OtherWinners = ({ caption_array, hasWon }) => (
    <div className="other-winners">
      {caption_array?.map((item) => (
        <>
          <p className="text">{`"${item.caption}"`}</p>
          <p className="by-user">{`by: ${
            hasWon ? "YOU!" : item.display_name
          }`}</p>
        </>
      ))}
    </div>
  );
  return (
    <div className="your-pick after-vote">
      <img src={logo} className="sw-logo mb-0" alt="logo" />
      <p className="txt">{_.isEmpty(userWon) ? lost_text : won_text_1}</p>
      <img src={photo} className="caption-img" alt="" />
      {userWon.length !== 0 ? (
        <>
          <OtherWinners caption_array={userWon} hasWon />
          <p className="wait-txt vote-percent mb-0">{`${percentage} ${won_text_2}`}</p>
          <p className="thanx mb-0">Other winners:</p>
          <OtherWinners caption_array={otherWinners} />
        </>
      ) : (
        <>
          <OtherWinners caption_array={otherWinners} />
          <p className="wait-txt vote-percent mb-0">{`${percentage} ${won_text_2}`}</p>
        </>
      )}
    </div>
  );
};

export default MultipleWinners;
